import React, { useEffect, useRef, useState } from 'react'
import { Link, Redirect, useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom'
import { getDateFormat, getTime, get_url_params, get_v10_url } from '../../utils/commonUtilities'
import api from '../../utils/apiRoutes'
import Cookies from 'js-cookie'
import { Button, Card, Col, DatePicker, Divider, Input, Modal, PageHeader, Row, Table, Tabs, Upload, message, notification } from 'antd'
import { SearchOutlined, UploadOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import dayjs from 'dayjs'
import { updateBooking, updateBookingLoading } from '../../actions/bookingActions'
import { connect } from 'react-redux'
import axios from 'axios'
import backIcon from '../../Assets/images/back-icon.svg'
import editIcon from '../../Assets/images/edit-icon.svg'
import timelineIcon from '../../Assets/images/timeline.svg'
import checkCircle from '../../Assets/images/check-circle.svg'
import EnhancementComponent from '../../Components/EnhancementComponent'
import ViewPdfModal from '../../Components/ViewPdfModal'
import GlobalLoader from '../../Components/GlobalLoader'

function SingleBooking(props) {

  const history = useHistory()

  const [pdfUrl, setPdfUrl] = useState('')
  const [bookingData, setBookingData] = useState(null)
  const [billHistoryFlag, setBillHistoryFlag] = useState(false)
  const [enhancementFlag, setEnhancementFlag] = useState(false)
  const [loading, setLoading] = useState(false)
  const [bookingId, setBookingId] = useState('')
  const [loadingDod, setLoadingDod] = useState(false)
  const [loadingReport, setLoadingReport] = useState(false)
  const [loadingBills, setLoadingBills] = useState(false)
  const [queryDocuments, setQueryDocuments] = useState({})
  const [data, setData] = useState([])
  const [enhancementLetter, setEnhancementLetter] = useState(false)
  const [activeKey, setActiveKey] = useState('1')
  const [dateOfDischarge, setDateOfDischarge] = useState("")
  const [documentModal, setDocumentModal] = useState(false);
  const dateFormat = 'DD-MMM-YYYY';
  const bigWindow = window.innerWidth > 1800 ? true : false
  const [documents, setDocuments] = useState({
    uploadedDocument: '',
    sNo: 0,
    uploadedOn: 0,
    type: 'PDF',
    url: ''
  })
  const [dischargeDocs, setDischargeDocs] = useState({
    docURL: '',
    updatedAt: '',
  })
  const [enhancementDocs, setEnhancementsDocs] = useState({
    letterUrl: '',
    date: '',
  })
  const [queryDocs, setQueryDocs] = useState({
    queryResponseUrl: '',
    updatedAt: '',
  })
  const [queryFromAwc, setQueryFromAwc] = useState({
    downloadUrl: '',
    updatedAt: ''
  })
  const [initialAlLetter, setInitialAlLetter] = useState({
    downloadUrl: '',
    updatedAt: '',
  })
  const [finalAlLetter, setFinalAlLetter] = useState({
    downloadUrl: '',
    updatedAt: '',
  })
  const [allBookingDoc, setAllBookingDoc] = useState([])
  const [showNotif, setShowNotif] = useState(false)
  const [patientDocuments, setPatientDocuments] = useState([])
  const [newUserDoc, setNewUserDoc] = useState({
    type: '',
    file: '',
    url: ''
  })
  const [uploadedFile, setUploadedFile] = useState(null)
  const [patientDocumentModal, setPatientDocumentModal] = useState(false)
  const [refresh, setRefresh] = useState(false)

  useEffect(() => {
    setLoading(true)
    const bookingId = get_url_params("id")
    if(!bookingId || bookingId.length === 0) {
      history.push("/dashboard")
    }
    setBookingId(bookingId)
    const headers  = { 'headers': { 'Authorization': `Bearer ${Cookies.get("token_medical_auth")}` } }
    const data = {
      booking_id: bookingId
    }
    api.booking.getBookingById(data, headers)
      .then((res) => {
        let booking = res.data[0].data[0]
        let apAmount = booking.paymentDetails? booking.paymentDetails.finalApproved ? booking.paymentDetails.finalApproved : booking.paymentDetails.initialApproved ? booking.paymentDetails.initialApproved : 0 : 0
        booking.amountDue = parseInt(apAmount) - parseInt((booking.paymentDetails && booking.paymentDetails.settledAmount) ? booking.paymentDetails.settledAmount : 0)
        // console.warn({booking})
        setQueryDocuments({
          _id: booking._id,
          queryUrl: booking.queryDoc && booking.queryDoc.queryUrl ? booking.queryDoc.queryUrl : null,
          queryResponseUrl: booking.queryDoc && booking.queryDoc.queryResponseUrl ? booking.queryDoc.queryResponseUrl : null
        })
        booking.timeLine = booking.timeLine ? booking.timeLine?.sort((a,b) => b.date - a.date) : []
        // console.warn("Booking timeline data: ", booking.timeLine);
        // console.log(booking);
        setBookingData(booking)
        // setDischargeDocs({
        //   docURL: booking.dischargeDoc?.docURL,
        //   updatedAt: dayjs(booking.dischargeDoc?.updatedAt).format(dateFormat)
        // })
        // setEnhancementsDocs({
        //   letterUrl: booking.enhancements?.length > 0 && booking.enhancements[booking.enhancements.length-1].letterUrl,
        //   date: booking.enhancements?.length > 0 && dayjs(booking.enhancements[booking.enhancements.length-1].date).format(dateFormat)
        // })
        let docs = []
        let j = 1
        let count = 1
        let countForAWC = 1
        let initialletter = 1
        let finalletter = 1
        let bookingsDocs = []
        let sNumber = 1
        let discharge = 0
        let enhancement = 0
        // console.log('setting booking timeline', booking.timeLine)
        for(let i=0; i<booking.timeLine.length; i++) {
          if(booking.timeLine[i].docURL === null) {
            continue
          }
          if(booking.timeLine[i].desc === "Query Response Document Recieved" && count===1) {
            setQueryDocs({
              queryResponseUrl: booking.timeLine[i].docURL,
              updatedAt: dayjs(booking.timeLine[i].date).format(dateFormat),
            })
            count += 1
          }
          if(booking.timeLine[i].desc === "Query Document Received" && countForAWC===1) {
            setQueryFromAwc(()=>({
              downloadUrl: booking.timeLine[i].docURL,
              updatedAt: dayjs(booking.timeLine[i].date).format(dateFormat),
            }))
            countForAWC += 1
          }
          if(booking.timeLine[i].desc === "Initial AL Letter Recieved" && initialletter===1) {
            setInitialAlLetter({
              downloadUrl: booking.timeLine[i].docURL,
              updatedAt: dayjs(booking.timeLine[i].date).format(dateFormat),
            })
            initialletter += 1
          }
          if(booking.timeLine[i].desc === "Final AL Letter Recieved" && finalletter===1) {
            setFinalAlLetter({
              downloadUrl: booking.timeLine[i].docURL,
              updatedAt: dayjs(booking.timeLine[i].date).format(dateFormat),
            })
            finalletter += 1
          }
          if(booking.timeLine[i].desc !== "Query Response Document Recieved" && booking.timeLine[i].desc !== "Query Document Recieved" && booking.timeLine[i].desc !== "Initial AL Letter Recieved" && booking.timeLine[i].desc !== "Final AL Letter Recieved" && booking.timeLine[i].desc !== "Discharge Document Recieved" && booking.timeLine[i].desc !== "Enhancement Letter Recieved") {
            const obj = {
              downloadUrl: booking.timeLine[i].docURL,
              updatedAt: dayjs(booking.timeLine[i].date).format(dateFormat),
              docName: booking.timeLine[i].desc,
              sNo: sNumber,
            }
            bookingsDocs.push(obj)
            sNumber += 1
          }
          if(discharge == 0) {
            if(booking.timeLine[i].task === "Discharge" && booking.timeLine[i].desc === "Discharge Document Received" && booking.timeLine[i].docURL) {
              discharge = 1
              setDischargeDocs({
                docURL: booking.timeLine[i].docURL,
                updatedAt: dayjs(booking.timeLine[i].date).format(dateFormat)
              })
            }
          }
          if(enhancement == 0) {
            if(booking.timeLine[i].task === "Processing" && booking.timeLine[i].desc === "Enhancement Letter Received" && booking.timeLine[i].docURL) {
              enhancement = 1
              setEnhancementsDocs({
                letterUrl: booking.timeLine[i].docURL,
                date: dayjs(booking.timeLine[i].date).format(dateFormat)
              })
            }
          }
          const splitDot = booking.timeLine[i].docURL.split('.')
          docs.push({
            sNo: j,
            uploadedDocument: booking.timeLine[i].desc,
            uploadedOn: dayjs(booking.timeLine[i].date).format(dateFormat),
            type: splitDot[splitDot.length-1].toUpperCase(),
            url: booking.timeLine[i].docURL
          })
          j += 1
        }
        setAllBookingDoc(bookingsDocs)
        setDocuments(docs)
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [refresh])

  useEffect(() => {
    props.setActiveSideKey('1')
  }, [])

  useEffect(() => {
    if(showNotif) {
      notification.success({
        message: 'Success',
        description: 'Booking updated successfully'
      })
      setShowNotif(false)
    }
  }, [showNotif])

  useEffect(() => {
    if(props.updateBookingRet) {
        // console.warn(props.updateBookingRet);
        if(props.updateBookingRet.success) {
            let booking = props.updateBookingRet.data
            // console.warn("update booking: ", booking)
            // notification.success({
            //   message: 'Success',
            //   description: 'Booking updated successfully'
            // })
            setShowNotif(true)
            // setDischargeDocs({
            //   docURL: booking.dischargeDoc?.docURL,
            //   updatedAt: dayjs(booking.dischargeDoc?.updatedAt).format(dateFormat)
            // })
            // setEnhancementsDocs({
            //   letterUrl: booking.enhancements?.length > 0 && booking.enhancements[booking.enhancements.length-1].letterUrl,
            //   date: booking.enhancements?.length > 0 && dayjs(booking.enhancements[booking.enhancements.length-1].date).format(dateFormat)
            // })
            booking.timeLine = booking.timeLine ? booking.timeLine?.sort((a,b) => b.date - a.date) : []
            let docs = []
            let j = 1
            let count = 1
            let discharge = 0
            let enhancement = 0
            for(let i=0; i<booking.timeLine.length; i++) {
              if(booking.timeLine[i].docURL === null) {
                continue
              }
              if(booking.timeLine[i].desc === "Query Response Document Recieved" && count===1) {
                setQueryDocs({
                  queryResponseUrl: booking.timeLine[i].docURL,
                  updatedAt: dayjs(booking.timeLine[i].date).format(dateFormat),
                })
                count += 1
              }
              if(discharge == 0) {
                if(booking.timeLine[i].task === "Discharge" && booking.timeLine[i].desc === "Discharge Document Received" && booking.timeLine[i].docURL) {
                  discharge = 1
                  setDischargeDocs({
                    docURL: booking.timeLine[i].docURL,
                    updatedAt: dayjs(booking.timeLine[i].date).format(dateFormat)
                  })
                }
              }
              if(enhancement == 0) {
                if(booking.timeLine[i].task === "Processing" && booking.timeLine[i].desc === "Enhancement Letter Received" && booking.timeLine[i].docURL) {
                  enhancement = 1
                  setEnhancementsDocs({
                    letterUrl: booking.timeLine[i].docURL,
                    date: dayjs(booking.timeLine[i].date).format(dateFormat)
                  })
                }
              }
              const splitDot = booking.timeLine[i].docURL.split('.')
              docs.push({
                sNo: j,
                uploadedDocument: booking.timeLine[i].desc,
                uploadedOn: dayjs(booking.timeLine[i].date).format(dateFormat),
                type: splitDot[splitDot.length-1].toUpperCase(),
                url: booking.timeLine[i].docURL
              })
              j += 1
            }
            setDocuments(docs)
        } else {
          notification.error({
            message: 'Error',
            description: 'Booking updated failed'
          })
        }
    }
  }, [props.updateBookingRet])

  useEffect(() => {
    // console.warn("you came back from: ", history.location);
    const state = history.location.state;
    if (state && state.activeTab === '4') {
      setActiveKey('2');
    } else if(state?.activeTab === '1') {
      setActiveKey('1')
    } else if(state?.activeTab === '3') {
      setActiveKey('3')
    }
  }, [history.location.state]);

  useEffect(()=>{
    if(!!props.upload_patient_report_ret){
            if(props.upload_patient_report_ret.success){
              let pdfUrls = []
              props.upload_patient_report_ret.data.reports.map((report) => {
                // console.log(report.url, "AAA")
                pdfUrls.push(report.url)
              })
              createUserReport(pdfUrls)  
        } else {
            notification["error"]({
                message: "Error",
                descriptioncess:"Upload Failed"
            });
        }
    }
    setLoadingReport(false)
    props.upload_patient_report_loading()

},[props.upload_patient_report_ret])

useEffect(() => {

  if (props.updateBookingRet) {
    if (props.updateBookingRet.success) {
      setLoadingDod(false)
      setLoadingBills(false)
      let booking = props.updateBookingRet.data
      let apAmount = booking.paymentDetails? booking.paymentDetails.finalApproved ? booking.paymentDetails.finalApproved : booking.paymentDetails.initialApproved ? booking.paymentDetails.initialApproved : 0 : 0
      booking.amountDue = parseInt(apAmount) - parseInt((booking.paymentDetails && booking.paymentDetails.settledAmount) ? booking.paymentDetails.settledAmount : 0)
      booking.timeLine = booking.timeLine ? booking.timeLine?.sort((a,b) => b.date - a.date) : []
      // setBookingData({...bookingData, dod: booking.dod, paymentDetails: booking.paymentDetails})
      setBookingData({
        ...bookingData,
        timeLine: booking.timeLine
      })
      // console.warn({booking})
      // message.success(`Booking updated`);
    } else {
      openNotificationWithIcon()
    }
    props.updateBookingLoading()
  }
}, [props.updateBookingRet])

const openNotificationWithIcon = () => {
  notification["error"]({
    message: 'Could not fetch details',
    description:
      'Please try again later',
  });
};

  const initialProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadBookingQueryDoc?bookingId=${bookingData?._id}&type=RESPONSE`,
    accept: "application/pdf",
    headers: {
      authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
    },
    beforeUpload: (file) => {
      const isPdf = file.type === 'application/pdf'
      const isLess5M = (file.size / 1024 / 1024) < 5
      if (!isPdf) {
        notification.error({
          message: 'Error',
          description: 'Please Upload PDF files only'
        })
      }
      if (!isLess5M) {
        notification.error({
          message: 'Error',
          description: 'Please upload files with size less than 5 MB'
        })
      }
      return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        // let tempData = data
        // tempData.map((booking) => {
        //   if (booking._id == resBooking.bookingId) {
        //     booking.dischargeDocs = resBooking.dischargeDocs
        //   }
        // })
        // setData(tempData)
        setQueryDocs({
          ...queryDocs,
          queryResponseUrl: resBooking.queryDoc
        })
        props.updateBooking({
          bookingId: bookingData._id
        })
        notification.success({
          message: 'Upload Successful',
          description: 'Query Document uploaded successfully'
        })
        // message.success(`Query Document uploaded successfully`);
      } else if (info.file.status === 'error') {
        notification.error({
          message: 'Upload Failed',
          description: 'Query Document upload failed'
        })
        // message.error(`Query Document upload failed.`);
      }
    },
    maxCount: 1
  };

  const enhancementProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadEnhancementLetter?bookingId=${queryDocuments._id}`,
    accept: "application/pdf",
    headers: {
      authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        setEnhancementLetter(true)
        setBookingData({...bookingData, enhancements: resBooking.enhancements})
        message.success(`Enhancement Letter uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`Enhancement Letter upload failed.`);
      }
    },
  };


  const dischargeProps = (record) => ({
    name: 'file',
    action: `${get_v10_url()}/professional/uploadDischargeDocument?bookingId=${record._id}`,
    accept: "application/pdf",
    headers: {
      authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        const resBooking = info.file.response.data
        let tempData = data
        tempData.map((booking) => {
          if (booking._id == resBooking.bookingId) {
            booking.queryDoc = resBooking.queryDoc
            setQueryDocuments({ ...queryDocuments, queryUrl: resBooking.queryDoc.queryUrl })
          }
        })
        setData(tempData)
        message.success(`Query Document uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`Query Document upload failed.`);
      }
    },
  });

  const donwloadImages = (imageUrls) => {
    let downloadUrls = []
    imageUrls.map((url) => {
      downloadUrls.push(url.imageUrl)
    })
    downloadUrls = downloadUrls.slice();
    downloadUrls.forEach(function (value, idx) {
        const response = {
          file: value,
        };
        setTimeout(() => {
            window.location.href = response.file;
        }, idx * 500)
    })
  }

  const donwloadInsuranceImages = (downloadUrls) => {
    downloadUrls = downloadUrls.slice();
    downloadUrls.forEach(function (value, idx) {
        const response = {
          file: value,
        };
        setTimeout(() => {
            window.location.href = response.file;
        }, idx * 500)
    })
  }

  const donwloadPdfs = (imageUrls) => {
    let downloadUrls = []
    imageUrls.map((url) => {
      downloadUrls.push(url.reportUrl)
    })
    downloadUrls = downloadUrls.slice();
    downloadUrls.forEach(function (value, idx) {
        const response = {
          file: value,
        };
        setTimeout(() => {
            window.location.href = response.file;
        }, idx * 500)
    })
  }

  const getDateString = (date) => {
    let ts = date.split("-")
    ts = ts[0] + "-" + ts[1].charAt(0).toUpperCase() + ts[1].charAt(1).toLowerCase() + ts[1].charAt(2).toLowerCase() + "-" + ts[2]
    return ts
  }


  const updateSessionBills=()=>{
    setLoadingBills(true)
    props.updateBooking({ bookingId: bookingData._id, finalAmount:bookingData.paymentDetails.finalBill, discount:bookingData.paymentDetails.discount, totalBill: bookingData.paymentDetails.totalBill, reason: bookingData.paymentDetails.billUpdateReason });
  }

  const addEnhancements=()=>{
    setLoadingBills(true)
    props.updateBooking({ bookingId: bookingData._id, 
      totalBill: Number(bookingData.paymentDetails?.package ? bookingData.paymentDetails?.package : 0) + Number(bookingData.paymentDetails?.roomRentNursing ? bookingData.paymentDetails?.roomRentNursing : 0) + Number(bookingData.paymentDetails?.cvc ? bookingData.paymentDetails?.cvc : 0) + Number(bookingData.paymentDetails?.otCharges ? bookingData.paymentDetails?.otCharges : 0) + Number(bookingData.paymentDetails?.soa ? bookingData.paymentDetails?.soa : 0) + Number(bookingData.paymentDetails?.investigation ? bookingData.paymentDetails?.investigation : 0) + Number(bookingData.paymentDetails?.medicineConsumables ? bookingData.paymentDetails?.medicineConsumables : 0) + Number(bookingData.paymentDetails?.others ? bookingData.paymentDetails?.others : 0), 
      others: bookingData.paymentDetails?.others, 
      discount: bookingData.paymentDetails?.discount,
      package: bookingData.paymentDetails?.package, 
      roomRentNursing: bookingData.paymentDetails?.roomRentNursing, 
      cvc: bookingData.paymentDetails?.cvc, 
      soa: bookingData.paymentDetails?.soa, 
      otCharges: bookingData.paymentDetails?.otCharges,
      investigation: bookingData.paymentDetails?.investigation,
      medicineConsumables: bookingData.paymentDetails?.medicineConsumables
    });
  }

  const updateSessionDod=()=>{
    setLoadingDod(true)
    props.updateBooking({ bookingId: bookingData._id, dod: dateOfDischarge });
  }


  const uploadDocs = async (e) => {
    e.preventDefault()
    setLoadingReport(true)
    const formData = new FormData()
    for (var i = 0; i < e.target.files.length; i++) {
        formData.append('file', e.target.files[i])
    }
    props.upload_patient_report({
        files: formData,
        type: "REPORT"
    })
}


  const createUserReport = async (pdfUrls) => {
    // console.log(pdfUrls)
    const headers  = { 'headers': { 'Authorization': `Bearer ${Cookies.get('token_medical_auth') }`} }
    const report = {
        userId: bookingData.userId,
        reportUrls: pdfUrls,
        description: bookingData.treatmentDetails,
        reportId: bookingData.userReportId,
        bookingId: bookingData._id
    }

    try {
        const reportData = await axios.post(`${get_v10_url()}/professional/updateBookingReport`, report, headers)
        let urls = []
        reportData.data.data.reportUrl.map((report) => {
          urls.push(report)
        })
        setBookingData({...bookingData, reportPdfs: urls})
        notification["success"]({
          message: "Succes",
          descriptioncess:"Upload successful"
      }); 
    } catch (error) {
      // console.log(error)
      notification["error"]({
        message: "Error",
        description: "An Error Occurred!! Please try again later.",
      });
    }
  }

  const downloadAll = async () => {
    bookingData?.timeLine?.map((t) => {
      if (t.docURL) {
        const url = t.docURL
        // console.log(url)
        const newIframe = document.createElement('iframe');
        newIframe.style.display = 'none';
        newIframe.src = url;
        document.body.appendChild(newIframe);

        newIframe.onload = function () {
          newIframe.contentWindow.print();
          document.body.removeChild(newIframe);
        }
        // document.body.removeChild(newIframe);
      }
    })
  }

  const documentColumns = [
    {
      title: <span>S. No.</span>,
      dataIndex: 'sNo',
      key: 'sNo',
      render: sNo => <span>{sNo}</span>
    },
    {
      title: <span>Uploaded Document</span>,
      dataIndex: 'uploadedDocument',
      key: 'uploadedDocument',
      render: docName => <span>{docName}</span>
    },
    {
      title: <span>Uploaded On</span>,
      dataIndex: 'uploadedOn',
      key: 'uploadedOn',
      render: timeStamp => <span>{timeStamp}</span>
    },
    {
      title: <span>Type</span>,
      dataIndex: 'type',
      key: 'type',
      render: _type => <span>{_type}</span>
    },
    // {
    //   title: <span>View</span>,
    //   dataIndex: 'url',
    //   key: 'view',
    //   render: link => (
    //     <a href={link} style={{ textDecoration: 'underline' }} target='_blank'>
    //       View
    //     </a>
    //   )
    // },
    {
      title: <span style={{display:'grid', placeContent:'center'}}>View</span>,
      dataIndex: 'url',
      key: 'download',
      render: link => (
        <div
          className="views-details-container"
          style={{ justifyContent: "center" }}
          onClick={()=>{
            setPdfUrl(()=>link)
          }}
        >
          <div className="views-details">
            <img src="/icons/view_eye_icon.svg" className="icon" />
            <p>View</p>
          </div>
        </div>
      )
    }
  ]

  const uploadDischargeProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadDischargeDocument?bookingId=${bookingData?._id}`,
    accept: 'application/pdf',
    headers : {
        authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
    },
    beforeUpload: (file) => {
        const isPdf = file.type === 'application/pdf'
        const isLess5M = (file.size / 1024 / 1024) < 5
        if (!isPdf) {
          notification.error({
            message: 'Error',
            description: 'Please Upload PDF files only'
          })
        }
        if (!isLess5M) {
          notification.error({
            message: 'Error',
            description: 'Please Upload file with size less than 5 MB'
          })
        }
        return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange(info) {
        if(info.file.status !== 'uploading') {
            // console.log(info.file, info.fileList);
        }
        if(info.file.status === 'done') {
            const resBooking = info.file.response.data
            setDischargeDocs({
              ...dischargeDocs,
              docURL: resBooking.dischargeDoc
            })
            props.updateBooking({bookingId: bookingData?._id,})
        } else if (info.file.status === 'error') {
          notification.error({
            message: 'Error',
            description: 'Upload Failed, please try again'
          })
        }
    }
  }

  const enhancementDocProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadEnhancementLetter?bookingId=${bookingData?._id}`,
    accept: 'application/pdf',
    headers : {
        authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
    },
    beforeUpload: (file) => {
        const isPdf = file.type === 'application/pdf'
        const isLess5M = (file.size / 1024 / 1024) < 5
        if (!isPdf) {
          notification.error({
            message: 'Error',
            description: 'Please Upload PDF files only'
          })
        }
        if (!isLess5M) {
          notification.error({
            message: 'Error',
            description: 'Please Upload file with size less than 5 MB'
          })
        }
        return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange(info) {
        if(info.file.status !== 'uploading') {
            // console.log(info.file, info.fileList);
        }
        if(info.file.status === 'done') {
            const resBooking = info.file.response.data
            setEnhancementsDocs({
              ...enhancementDocs,
              letterUrl: resBooking.enhancements
            })
            props.updateBooking({bookingId: bookingData?._id,})
        } else if (info.file.status === 'error') {
          notification.error({
            message: 'Error',
            description: 'Upload Failed, please try again'
          })
        }
    }
  }

  const handleAddNewDoc = () => {
    if (!newUserDoc.type) {
        notification["error"]({
            message: "Error",
            description: "Please enter document name for the file to be uploaded",
        })
        return
    }
    if (!newUserDoc.file) {
        notification["error"]({
            message: "Error",
            description: "Please select a file to be uploaded",
        })
        return
    }
    setPatientDocuments([
        ...patientDocuments,
        newUserDoc
    ])
    setUploadedFile(null)
    setNewUserDoc({
        type: null,
        file: '',
        url: ''
    })
  }

  const deleteUserDoc = (index) => {
    let temp = [...patientDocuments]
    temp.splice(index, 1)
    setPatientDocuments(temp)
  }

  const docProps = {
    name: 'file',
    action: `${get_v10_url()}/professional/uploadBookingDoc`,
    accept: "application/pdf",
    headers: {
      authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
    },
    beforeUpload: (file) => {
        const isPdf = file.type === 'application/pdf'
        const isLess5M = (file.size / 1024 / 1024) < 5
        if (!isPdf) {
          notification.error({
            message: 'Error',
            description: 'Please Upload PDF files only'
          })
        }
        if (!isLess5M) {
          notification.error({
            message: 'Error',
            description: 'Please upload files with size less than 5 MB'
          })
        }
        return (isPdf && isLess5M) || Upload.LIST_IGNORE;
    },
    onChange(info) {
        if (info.file.status !== 'removed') {
            setUploadedFile(info.file)
        }
        if (info.file.status !== 'uploading') {
            // console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
            const resBooking = info.file.response.data
            setNewUserDoc({
                ...newUserDoc,
                url: resBooking.docURL,
                file: info.file.name
            })
            notification.success({
              message: "Success",
              description: "Document uploaded successfully"
            })
        } else if (info.file.status === 'error') {
            notification.error({
              message: "Error",
              description: "Couldn't upload document"
            })
        }
    },
    onRemove() {
        setNewUserDoc({
            type: null,
            file: '',
            url: ''
        })
        setUploadedFile(null)
    }
  }

  const handleSubmitUplodedDocuments = () => {
    if(newUserDoc.type!=='' && newUserDoc.type!==undefined && newUserDoc.type!==null) {
      notification.error({
        message: "Error",
        description: "You have entered some text in input, if You want to upload the document click on 'add' or remove the entered text"
      })
      return
    }
    if(newUserDoc.url!=='' && newUserDoc.url!==undefined && newUserDoc.url!==null) {
      notification.error({
        message: "Error",
        description: "You have uploaded a document, if You want to add this document click on 'add' or remove the uploded document"
      })
      return
    }
    if(patientDocuments.length === 0) {
      notification.error({
        message: "Error",
        description: "Please add at least one document to submit."
      })
      return
    }
    props.updateBooking({
      bookingId: bookingData._id,
      bookingDocuments: patientDocuments,
    })
    setPatientDocumentModal(false)
    setPatientDocuments([])
  }

  return (
    <>
    {loading && <GlobalLoader/>}
    <div className='single-booking-container'>
      <Card className = 'bookings-card-container single-booking-card-container' loading={loading} 
        style={{ width: '100%', height: '100%' }}
        headStyle={{ marginLeft: '180px', height: '64px', width: 'calc(100vw - 200px)', zIndex: '300', position: 'relative' }} 
        title={<PageHeader title={<div>            
          <h3 style={{fontWeight:'600'}}>{bookingData?.patientName}</h3>
        </div>} onBack={() => history.push("/dashboard/booking-details")} backIcon={<img src={backIcon} style={{ filter:'invert(99%) sepia(1%) saturate(123%) hue-rotate(251deg) brightness(117%) contrast(100%)' }} />} />}
      >
        <div className='heading-buttons'>
          <h4 className={`${activeKey==='1' && 'active'}`} onClick={()=>{history.push(`/dashboard/booking/booking-details?id=${bookingId}`, {activeTab: '1'}); setActiveKey('1'); setRefresh(!refresh)}}>All Details</h4>
          <h4 className={`${activeKey==='2' && 'active'}`} onClick={()=>{history.push(`/dashboard/booking/booking-details?id=${bookingId}`, {activeTab: '4'}); setActiveKey('2')}}>Enhancements</h4>
          <h4 className={`${activeKey==='3' && 'active'}`} onClick={()=>{history.push(`/dashboard/booking/booking-details?id=${bookingId}`, {activeTab: '3'}); setActiveKey('3'); setRefresh(!refresh)}}>Documents</h4>
        </div>
        <div className='single-booking-body-container'>

          {activeKey==='1' && (
            <div className='booking-all-details-container'>
              <Row gutter={24}>
                <Col span={16}>
                  <div className='single-details-container'>
                    <div className='single-details-heading round'>
                      <h3>Patient Details</h3>
                      {/* <img src={editIcon}/> */}
                    </div>
                    <div className='single-details-body'>
                      <Row gutter={24}>
                        <Col span={8}>
                          <span>Patient Name</span>
                          <p style={{wordBreak:'break-all'}}>{bookingData?.patientName}</p>
                        </Col>
                        <Col span={8}>
                          <span>Mobile Number</span>
                          <p>{bookingData?.patientMobileNumber}</p>
                        </Col>
                        <Col span={8}>
                          <span>Alternate Number</span>
                          <p>{bookingData?.userAlternateNumber || '-'}</p>
                        </Col>
                      {/* </Row>
                      <Row gutter={24}> */}
                        <Col span={8}>
                          <span>Age</span>
                          <p>{(bookingData?.patientAge || bookingData?.patientAge==0) ? bookingData?.patientAge +' yrs' : '-'}</p>
                        </Col>
                        <Col span={8}>
                          <span>Dob</span>
                          <p>{bookingData?.patientDob ? bookingData?.patientDob : '-'}</p>
                        </Col>
                        <Col span={8}>
                          <span>Gender</span>
                          <p>{bookingData?.patientSex ? `${bookingData?.patientSex==='M' ? 'Male' : bookingData?.patientSex==='F' ? 'Female' : 'Others'}` : '-' }</p>
                        </Col>
                        <Col span={8}>
                          <span>Patient Email</span>
                          <p style={{wordBreak:'break-all'}}>{bookingData?.patientEmail}</p>
                        </Col>
                      {/* </Row> */}
                      {/* <Row gutter={24}> */}
                        <Col span={8}>
                          <span>Treatment Type</span>
                          <p>{bookingData?.treatment ? bookingData?.treatment : '-'}</p>
                        </Col>
                        <Col span={8}>
                          <span>Patient Address</span>
                          <p>{bookingData?.patientAddress ? bookingData?.patientAddress : "-"}</p>
                        </Col>
                        <Col span={8}>
                          <span>PL Number</span>
                          <p>{bookingData?.plNumber ? bookingData?.plNumber : "-"}</p>
                        </Col>
                      {/* </Row>
                      <Row gutter={24}> */}
                        {bookingData?.treatment === 'Surgical Management' ? (
                          <>
                          <Col span={8}>
                            <span>Treating Surgeon's Name</span>
                            <p style={{wordBreak:'break-all'}}>{bookingData?.treatingSurgeon ? bookingData?.treatingSurgeon : '-'}</p>
                          </Col>
                          </>
                        ) : (
                          <>
                          <Col span={8}>
                            <span>Consulting Doctor's Name</span>
                            <p style={{wordBreak:'break-all'}}>{bookingData?.doctorName ? bookingData?.doctorName : '-'}</p>
                          </Col>
                          </>
                        )}
                        <Col span={8}>
                          <span>Medical Certificate Number</span>
                          <p>{bookingData?.medicalCertificateNumber ? bookingData?.medicalCertificateNumber : "-"}</p>
                        </Col>
                        <Col span={8}>
                          <span>Doctor's Contact Number</span>
                          <p>{bookingData?.doctorContactNumber ? bookingData?.doctorContactNumber : "-"}</p>
                        </Col>
                      {/* </Row>
                      <Row gutter={24}> */}
                        <Col span={8}>
                          <span>Procedure Details</span>
                          <p>{bookingData?.treatmentDetails ? bookingData?.treatmentDetails : "-"}</p>
                        </Col>
                      </Row>
                    </div>
                    <div className='single-details-heading'>
                      <h3>Policy Details</h3>
                      {/* <img src={editIcon}/> */}
                    </div>
                    <div className='single-details-body'>
                      <Row gutter={24}>
                        <Col span={8}>
                          <span>Policy Number</span>
                          <p>{bookingData?.insuranceDetails?.policyNumber ? bookingData?.insuranceDetails?.policyNumber : "N/A"}</p>
                        </Col>
                        <Col span={8}>
                          <span>Policy Type</span>
                          <p>{bookingData?.insuranceDetails?.policyType ? bookingData?.insuranceDetails?.policyType : "-"}</p>
                        </Col>
                        {bookingData?.insuranceDetails?.insurancePartner === "CASH" && <Col span={8}>
                          <span>Policy Name</span>
                          <p>Policy type not specified</p>
                        </Col>}
                        {bookingData?.insuranceDetails?.policyType === "Retail Policy" && <Col span={8}>
                          <span>Retail Name</span>
                          <p>{bookingData?.insuranceDetails?.retailPolicy ? bookingData?.insuranceDetails?.retailPolicy : "-"}</p>
                        </Col>}
                        {bookingData?.insuranceDetails?.policyType === "Corporate Policy" && <Col span={8}>
                          <span>Corporate Policy Name</span>
                          <p>{bookingData?.insuranceDetails?.corporatePolicy ? bookingData?.insuranceDetails?.corporatePolicy : "-"}</p>
                        </Col>}
                      </Row>
                      <Row gutter={24}>
                        <Col span={8}>
                          <span>Booking Created Date</span>
                          <p>{bookingData?.createdAt ? dayjs(bookingData?.createdAt).format(dateFormat) : "-"}</p>
                        </Col>
                        <Col span={8}>
                          <span>Date Of Admission</span>
                          <p>{bookingData?.doa ? bookingData?.doa : "-"}</p>
                        </Col>
                        <Col span={8}>
                          <span>Date Of Discharge</span>
                          <p>{bookingData?.dod ? bookingData?.dod : "-"}</p>
                        </Col>
                      </Row>
                      <Row gutter={24}>
                        <Col span={8}>
                          <span>Room Rent/Day</span>
                          <p>{ bookingData?.paymentDetails?.roomRent?.toString() ? (isNaN(bookingData?.paymentDetails?.roomRent) ? '-' : `₹ ${Number(bookingData?.paymentDetails?.roomRent).toLocaleString('en-IN')}`) : '-'}</p>
                        </Col>
                        <Col span={8}>
                          <span>Total Room Rent</span>
                          <p>{ bookingData?.paymentDetails?.totalRoomRent?.toString() ? (isNaN(bookingData?.paymentDetails?.totalRoomRent) ? '-' : `₹ ${Number(bookingData?.paymentDetails?.totalRoomRent).toLocaleString('en-IN')}`) : '-'}</p>
                        </Col>
                        <Col span={8}>
                          <span>Discount</span>
                          <p>{ bookingData?.paymentDetails?.discount?.toString() ? (isNaN(bookingData?.paymentDetails?.discount) ? '-' : `₹ ${Number(bookingData?.paymentDetails?.discount).toLocaleString('en-IN')}`) : '-'}</p>
                        </Col>
                      </Row>
                      <Row gutter={24}>
                        <Col span={8}>
                          <span>Cost Estimation</span>
                          <p>{ (bookingData?.paymentDetails?.sourcingCost || bookingData?.paymentDetails?.sourcingCost==0) ? (isNaN(bookingData?.paymentDetails?.sourcingCost) ? '-' : `₹ ${Number(bookingData?.paymentDetails?.sourcingCost).toLocaleString('en-IN')}`) : '-'}</p>
                        </Col>
                        <Col span={8}>
                          <span>Al Number</span>
                          <p>{bookingData?.alNumber ?? '-'}</p>
                        </Col>
                        <Col span={8}>
                          <span>Room Category</span>
                          <p>{bookingData?.paymentDetails?.roomCategory ? bookingData?.paymentDetails?.roomCategory==="OTHERS" ? `Others (${bookingData?.paymentDetails?.specifiedRoomCategory})`: bookingData?.paymentDetails?.roomCategory : "-"}</p>
                        </Col>
                      </Row>
                      <Row gutter={24}>
                        <Col span={8}>
                          <span>Insurance Provider</span>
                          <p>{bookingData?.insuranceDetails?.insurancePartner ? bookingData?.insuranceDetails?.insurancePartner : "N/A"}</p>
                        </Col>
                        <Col span={8}>
                          <span>Insurance Company Name</span>
                          <p>{bookingData?.insuranceDetails?.serviceTPA ? bookingData?.insuranceDetails?.serviceTPA : "N/A"}</p>
                        </Col>
                        <Col span={8}>
                          <span>UHID/Member ID</span>
                          <p>{bookingData?.cardNumber ? bookingData?.cardNumber : "-"}</p>
                        </Col>
                        {/* <Col span={8}>
                          <span>Hospital</span>
                          <p>{bookingData?.professionalName ? bookingData?.professionalName : "-"}</p>
                        </Col> */}
                      </Row>
                    </div>
                  </div>
                </Col>
                <Col span={8}>
                  <div className='timeline-container'>
                    <Button className='booking-view-doc-btn' onClick={() => setDocumentModal(true)} >View Documents</Button>
                    <Card className='booking-timeline-card' title={(<><img src={timelineIcon} alt='icon'/><p>Timeline</p></>)}>
                      {
                        bookingData?.timeLine ? bookingData?.timeLine?.map((ele, idx) => (
                          <div className='booking-timeline-container' key={idx}>
                            <div className='side-icons'>
                              <img src={checkCircle} alt='circle'/>
                              <div className='divider-vertical' style={{height:`${ele.docURL ? '60px' : '40px'}`}}></div>
                            </div>
                            <div>
                              <p className='booking-timeline-stage'>{ ele.task }</p>
                              <p className='booking-timeline-status'>{ ele.desc }</p>
                              <span className='booking-timeline-time'>{getDateFormat(ele.date)}, {getTime(ele.date)}</span>
                              { ele.docURL && <div className='booking-timeline-link'>
                                <button className='view-document' onClick={()=>setPdfUrl(ele.docURL)}>View</button>
                              </div>}
                            </div>
                          </div>
                        )) : <></>
                      }
                    </Card>
                  </div>
                </Col>
              </Row>
            </div>
          )}

          {activeKey==='2' && (
            <EnhancementComponent data={bookingData} />
          )}

          {activeKey==='3' && (<>
          {/* <Button
            style={{
              backgroundColor: '#01D35A',
              color: '#FFF',
              fontSize: '16px',
              fontWeight: '600',
              border: '1px solid #e4e4e4',
              borderRadius: '11px',
              minHeight: '55px',
              position: 'absolute',
              top: '5.5rem',
              right: '1.5rem'
            }}
            icon={<UploadOutlined style={{color:'#FFFFFF'}}/>}
          >
            Upload New
          </Button> */}
          <div className='booking-documents-table-container'>
            <h3>Documents</h3>
            <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
              <h2 style={{ fontWeight: 'bold', padding: '20px 0px 20px 20px' }}>
                Uploaded Documents for {bookingData?.patientName}
              </h2>
              <Button type='primary' onClick={()=>setPatientDocumentModal(true)} style={{backgroundColor:'#01D35A', border:'none', borderRadius:'8px', marginRight:'20px'}} icon={<UploadOutlined/>} >Upload</Button>
            </div>
            <Table
              columns={documentColumns}
              dataSource={documents}
              rowKey={record => record.sNo}
              className='booking-documents-table'
            />
          </div>
          </>)}
        </div>
      </Card>
      {patientDocumentModal &&
      <Modal
        title={`Upload documents for ${bookingData?.userName}`}
        open={patientDocumentModal}
        width="80%"
        className='patient-doc-modal'
        onCancel={() => setPatientDocumentModal(false)}
        onOk = {() => setPatientDocumentModal(false)}
      >
        {patientDocuments.map((doc, index) => (
          <Row gutter={24} key={index} style={{ width: '100%', alignItems: 'center', marginBottom: '16px' }}>
            <Col span={12}>
              <Input value={doc.type} disabled={true} className='doc-imput'/>
            </Col>
            <Col span={6}>
              <Input value={doc.file} disabled={true} className='doc-imput form-input-upload'/>
            </Col>
            <Col span={6} style={{ paddingLeft: '20px', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <Button type='link' onClick={() => deleteUserDoc(index)} className='remove-link-upload'>Remove</Button>
            </Col>
          </Row>
        ))}
        <Row gutter={24} justify={"middle"}>
          <Col span={12}>
            <Input value={newUserDoc.type} onChange={e=>setNewUserDoc({...newUserDoc, type:e.target.value})} placeholder='Enter Document Name' className='doc-imput'/>
          </Col>
          <Col span={6}>
            <Upload { ...docProps } fileList={uploadedFile ? [uploadedFile] : []} className='booking-upload-docs-container'>
              <Button icon={<UploadOutlined />} className='booking-upload-docs-btn'>Upload Doc</Button>
            </Upload>
          </Col>
          <Col span={6} style={{paddingLeft:'24px'}}>
            <Button onClick={handleAddNewDoc} className='booking-add-new-doc-btn'>Add</Button>
          </Col>
        </Row>
        <div className='submit-btn-cont'>
          <Button className='booking-add-new-doc-btn' onClick={()=>handleSubmitUplodedDocuments()}>Submit</Button>
        </div>
      </Modal>}
      {pdfUrl && <ViewPdfModal openPDFModal={pdfUrl} setOpenPDFModal={setPdfUrl} pdfUrl={pdfUrl} />}
      <Modal
        title={`Documents uploaded for ${bookingData?.patientName}`}
        open={documentModal}
        width="80%"
        cancelButtonProps={{ style: { display: "none" } }}
        onCancel={() => setDocumentModal(false)}
        onOk = {() => {
          setDocumentModal(false)
          window.location.reload();
        }}
      >
        <Card style={{ borderWidth: '0px' }}>
          <Row gutter={24} style={{ fontWeight: 'bold' }}>
            <Col span={bigWindow ? 1 : 2}>
              S No.
            </Col>
            <Col span={6}>
              Veiw Documents
            </Col>
            <Col span={bigWindow ? 6 : 5}>
              Uploaded On
            </Col>
            <Col span={5}>
              Document Type
            </Col>
            <Col span={6}>
              Upload Documents
            </Col>
          </Row>
          {
            bookingData?.alLetterDetails && (bookingData?.alLetterDetails?.initialLetter?.length > 0 || bookingData.alLetterDetails.finalLetter?.length > 0) ?
            <Card title="AL Letters" className='document-card'>
              {initialAlLetter?.downloadUrl && <Row gutter={24} className='document-card-row'>
                <Col span={bigWindow ? 1 : 2}>
                  <span>1</span>
                </Col>
                <Col span={6}>
                    <a onClick={()=>{setPdfUrl(initialAlLetter?.downloadUrl)}}>View Initial Letter</a>
                </Col>
                <Col span={bigWindow ? 6 : 5}>
                  {initialAlLetter?.updatedAt}
                </Col>
                <Col span={5}>
                  PDFs
                </Col>
                <Col span={6}>
                  -
                </Col>
              </Row>}
              {finalAlLetter?.downloadUrl && <Row gutter={24} className='document-card-row'>
                <Col span={bigWindow ? 1 : 2}>
                  <span>{initialAlLetter?.downloadUrl ? '2' : '1'}</span>
                </Col>
                <Col span={6}>
                    <a onClick={()=>{setPdfUrl(finalAlLetter?.downloadUrl)}}>Download Final Letter</a>
                </Col>
                <Col span={bigWindow ? 6 : 5}>
                  {finalAlLetter?.updatedAt}
                </Col>
                <Col span={5}>
                  PDFs
                </Col>
                <Col span={6}>
                  -
                </Col>
              </Row>}
            </Card>
            : <></>
          }
          {
            bookingData?.dischargeDoc && bookingData?.dischargeDoc?.docUploaded ?
            <Card title="Discharge Documents" className='document-card'>
              <Row gutter={24} className='document-card-row'>
                <Col span={bigWindow ? 1 : 2}>
                  <span>1</span>
                </Col>
                <Col span={6}>
                  <a onClick={()=>{setPdfUrl(bookingData?.dischargeDoc?.docURL)}}>View Discharge Document</a>
                </Col>
                <Col span={bigWindow ? 6 : 5}>
                  {dischargeDocs?.updatedAt}
                </Col>
                <Col span={5}>
                  PDFs
                </Col>
                <Col span={6}>
                  -
                </Col>
                {/* <Col span={12}>
                  <div className='document-btns'>
                    <div className='btns'><Button onClick={() => setEnhancementFlag(true)}>See Enhancement Letter</Button></div>
                    <div className='btn-icon'><Button onClick={() => setEnhancementFlag(true)}><EyeOutlined /></Button></div>
                  </div>
                </Col> */}
              </Row>
            </Card> : <></>
          }
          {
            bookingData?.enhancements && bookingData?.enhancements?.length > 0 ?
            <Card title="Enhancement Letters" className='document-card'>
              <Row gutter={24} className='document-card-row'>
                <Col span={bigWindow ? 1 : 2}>
                  <span>1</span>
                </Col>
                <Col span={6}>
                  <a onClick={()=>{setPdfUrl(enhancementDocs.letterUrl)}}>See Enhancement Letter</a>
                </Col>
                <Col span={bigWindow ? 6 : 5}>
                  {enhancementDocs.date}
                </Col>
                <Col span={5}>
                  PDFs
                </Col>
                <Col span={6}>
                  -
                </Col>
              </Row>
            </Card> : <></>
          }
          { bookingData?.queryDoc?.queryReceived &&
          (<Card title="Query" className='document-card'>
            <Row gutter={24} className='document-card-row'>
              {/* <Col span={queryDocuments && queryDocuments.queryResponseUrl ? 8 : 12}>
                {queryDocuments && queryDocuments.queryUrl ? 
                <div className='query-document'>
                  <div className='query-document-btn'><a href={queryDocuments.queryUrl}>Download Uploaded Document</a></div>
                  <div className='query-document-icon'><a href={queryDocuments.queryUrl}><DownloadOutlined /></a></div>
                </div> : "No Query recieved"}
              </Col>
              <Col span={queryDocuments && queryDocuments.queryResponseUrl ? 8 : 12}>
                <Upload {...initialProps}>
                  <div className='document-btns'>
                    <div className='btns'><Button>{queryDocuments.queryResponseUrl ? "Update " : "Upload "} Query Document</Button></div>
                    <div className='btn-icon'><Button><UploadOutlined /></Button></div>
                  </div>
                </Upload>
              </Col>
              <Col span={8}>
                {queryDocuments && queryDocuments.queryResponseUrl &&
                <div className='query-document'>
                  <div className='query-document-btn'><a href={queryDocuments.queryResponseUrl}>Download Query Response</a></div>
                  <div className='query-document-icon'><a href={queryDocuments.queryResponseUrl}><DownloadOutlined /></a></div>
                </div>}
              </Col> */}
              <Col span={bigWindow ? 1 : 2}>
                <span>1</span>
              </Col>
              <Col span={6}>
                <a onClick={()=>{
                  setPdfUrl(queryFromAwc.downloadUrl)
                }}>View Query Doc</a>
              </Col>
              <Col span={bigWindow ? 6 : 5}>
                {queryFromAwc.updatedAt}
              </Col>
              <Col span={5}>
                PDFs
              </Col>
              <Col span={6}>
                -
              </Col>
            </Row>
          </Card>)
          }
          <Card title="Query Response" className='document-card'>
            <Row gutter={24} className='document-card-row'>
              {/* <Col span={queryDocuments && queryDocuments.queryResponseUrl ? 8 : 12}>
                {queryDocuments && queryDocuments.queryUrl ? 
                <div className='query-document'>
                  <div className='query-document-btn'><a href={queryDocuments.queryUrl}>Download Uploaded Document</a></div>
                  <div className='query-document-icon'><a href={queryDocuments.queryUrl}><DownloadOutlined /></a></div>
                </div> : "No Query recieved"}
              </Col>
              <Col span={queryDocuments && queryDocuments.queryResponseUrl ? 8 : 12}>
                <Upload {...initialProps}>
                  <div className='document-btns'>
                    <div className='btns'><Button>{queryDocuments.queryResponseUrl ? "Update " : "Upload "} Query Document</Button></div>
                    <div className='btn-icon'><Button><UploadOutlined /></Button></div>
                  </div>
                </Upload>
              </Col>
              <Col span={8}>
                {queryDocuments && queryDocuments.queryResponseUrl &&
                <div className='query-document'>
                  <div className='query-document-btn'><a href={queryDocuments.queryResponseUrl}>Download Query Response</a></div>
                  <div className='query-document-icon'><a href={queryDocuments.queryResponseUrl}><DownloadOutlined /></a></div>
                </div>}
              </Col> */}
              <Col span={bigWindow ? 1 : 2}>
                <span>1</span>
              </Col>
              <Col span={6}>
                {queryDocs.queryResponseUrl ? <a onClick={()=>{
                  setPdfUrl(queryDocs.queryResponseUrl.queryResponseUrl)
                }}>View Query Response</a> : queryFromAwc.downloadUrl ? 'Query Recieved' : 'No Query Recieved'}
              </Col>
              <Col span={bigWindow ? 6 : 5}>
                {queryDocs.updatedAt ? queryDocs.updatedAt : '-'}
              </Col>
              <Col span={5}>
                PDFs
              </Col>
              <Col span={6}>
                <Upload {...initialProps}>
                  <div className='document-btns'>
                    <div className='btns'><a>{queryDocs.queryResponseUrl ? "Update " : "Upload "} Query Response</a></div>
                  </div>
                </Upload>
              </Col>
            </Row>
          </Card>
          {/* {
            bookingData?.insuranceDetails && (bookingData?.insuranceDetails?.insuranceCard?.length > 0 || bookingData?.insuranceDetails?.insurancePolicy?.length) > 0 ?
            <Card title="Insurance Documents" className='document-card'>
              <Row gutter={24} className='document-card-row'> */}
                {/* <Col span={12}>
                  {bookingData.insuranceDetails.insuranceCard?.length ?
                    <div className='document-btns'>
                      <div className='btns'><Button onClick={() => donwloadInsuranceImages(bookingData.insuranceDetails.insuranceCard)}>Download Insurance Card Images</Button></div>
                      <div className='btn-icon'><Button onClick={() => donwloadInsuranceImages(bookingData.insuranceDetails.insuranceCard)}><DownloadOutlined /></Button></div>
                    </div> : "No images uploaded"}
                </Col>
                <Col span={12}>
                  {bookingData.insuranceDetails.insurancePolicy?.length ?
                    <div className='document-btns'>
                      <div className='btns'><Button onClick={() => donwloadInsuranceImages([bookingData.insuranceDetails.insurancePolicy])}>Download Insurance Policy PDFS</Button></div>
                      <div className='btn-icon'><Button onClick={() => donwloadInsuranceImages([bookingData.insuranceDetails.insurancePolicy])}><DownloadOutlined /></Button></div>
                    </div> : "No pdfs uploaded"}
                </Col> */}
                {/* <Col span={bigWindow ? 1 : 2}>
                  <span>1</span>
                </Col>
                <Col span={6}>
                  {bookingData.insuranceDetails.insuranceCard?.length ?
                    <a onClick={() => donwloadInsuranceImages(bookingData.insuranceDetails.insuranceCard)}>Download Insurance Card Images</a>
                    : "No images uploaded"}
                </Col>
                <Col span={bigWindow ? 6 : 5}>
                  -
                </Col>
                <Col span={6}>
                  Images
                </Col>
                <Col span={5}>
                  -
                </Col>
              </Row>
              <Row gutter={24} className='document-card-row'>
                <Col span={bigWindow ? 1 : 2}>
                  <span>2</span>
                </Col>
                <Col span={6}>
                  {bookingData.insuranceDetails.insurancePolicy?.length ?
                    <a onClick={() => donwloadInsuranceImages([bookingData.insuranceDetails.insurancePolicy])}>Download Insurance Policy PDFS</a>
                    : "No pdfs uploaded"}
                </Col>
                <Col span={bigWindow ? 6 : 5}>
                  -
                </Col>
                <Col span={6}>
                  PDFs
                </Col>
                <Col span={5}>
                  -
                </Col>
              </Row>
            </Card> : <></>
          } */}
          {/* {
            bookingData !== null && bookingData?.reportImages?.length > 0 || bookingData?.reportPdfs?.length > 0 ?
            <Card title="User Reports" className='document-card'> */}
              {/* <Row gutter={24}>
                <Col span={12}>
                  {bookingData.reportImages?.length ?
                    <div className='document-btns'>
                      <div className='btns'><Button onClick={() => donwloadImages(bookingData.reportImages)}>Download All Images</Button></div>
                      <div className='btn-icon'><Button onClick={() => donwloadImages(bookingData.reportImages)}><DownloadOutlined /></Button></div>
                    </div> : "No images uploaded"}
                </Col>
                <Col span={12}>
                  {bookingData.reportPdfs?.length ?
                    <div className='document-btns'>
                      <div className='btns'><Button onClick={() => donwloadPdfs(bookingData.reportPdfs)}>Download All Pdfs</Button></div>
                      <div className='btn-icon'><Button onClick={() => donwloadPdfs(bookingData.reportPdfs)}><DownloadOutlined /></Button></div>
                    </div> : "No pdfs uploaded"}
                </Col>
              </Row> */}
              {/* <Row gutter={24} className='document-card-row'>
                <Col span={bigWindow ? 1 : 2}>
                  <span>1</span>
                </Col>
                <Col span={6}>
                  {bookingData.reportImages?.length ?
                    <a onClick={() => donwloadImages(bookingData.reportImages)}>Download All Images</a>
                    : "No images uploaded"}
                </Col>
                <Col span={bigWindow ? 6 : 5}>
                  -
                </Col>
                <Col span={6}>
                  Images
                </Col>
                <Col span={5}>
                  -
                </Col>
              </Row>
              <Row gutter={24} className='document-card-row'>
                <Col span={bigWindow ? 1 : 2}>
                  <span>2</span>
                </Col>
                <Col span={6}>
                  {bookingData.insuranceDetails.insurancePolicy?.length ?
                    <a onClick={() => donwloadPdfs(bookingData.reportPdfs)}>Download All PDFs</a>
                    : "No pdfs uploaded"}
                </Col>
                <Col span={bigWindow ? 6 : 5}>
                  -
                </Col>
                <Col span={6}>
                  PDFs
                </Col>
                <Col span={5}>
                  -
                </Col>
              </Row>
            </Card> : <></>
          } */}
                    {
            allBookingDoc && allBookingDoc?.length > 0 ?
            <Card title='Documents' className='document-card'>
              {allBookingDoc.map((doc,index) => (
                <Row gutter={24} className='document-card-row' key={index}>
                <Col span={bigWindow ? 1 : 2}>
                  <span>{doc.sNo}</span>
                </Col>
                <Col span={6}>
                  <a onClick={()=>{setPdfUrl(doc.downloadUrl)}}>{doc.docName}</a>
                </Col>
                <Col span={bigWindow ? 6 : 5}>
                  {doc.updatedAt}
                </Col>
                <Col span={6}>
                  PDFs
                </Col>
                <Col span={5}>
                  -
                </Col>
                {/* <Col span={12}>
                  <div className='document-btns'>
                    <div className='btns'><Button onClick={() => setEnhancementFlag(true)}>See Enhancement Letter</Button></div>
                    <div className='btn-icon'><Button onClick={() => setEnhancementFlag(true)}><EyeOutlined /></Button></div>
                  </div>
                </Col> */}
              </Row>
              ))}
            </Card> : <></>
          }
        </Card>
      </Modal>
    </div>
    </>
  )

}


const mapStateToProps = (state) => ({
  updateBookingLoadingFlag: state.bookingStore.updateBookingLoading,
  updateBookingRet: state.bookingStore.updateBookingRet,
});

export default connect(mapStateToProps, {
  updateBooking,
  updateBookingLoading
})(SingleBooking);